<section class="home">
  <h1 class="home__title">Ops IQ</h1>
  <p class="home__welcome">Welcome, {{ email() }}</p>
  <p class="home__meta">Roles: {{ roles().join(', ') || '(none)' }}</p>
  @if (isAdmin()) {
    <p class="home__meta">You have administrator access.</p>
  }
</section>
